<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="'Submit'"
    :btn-loading="loading"
    :submit-btn-disabled="loading || isSealedUnitOverbooked"
  >
    <template slot="header">
      <span>{{ status_id == glassStatusIdNew ? 'Issue' : 'Undo Issue' }} PO# {{ po_number }}</span>
    </template>
    <template slot="body">
      <v-row>
        <v-col
          v-if="status_id == glassStatusIdNew"
          cols="12"
        >
          <v-autocomplete
            v-model="location_id"
            :items="locations"
            auto-select-first
            item-text="name"
            item-value="id"
            :rules="[(v) => !!v || 'Expected Shipping Location is required']"
          >
            <template slot="label">
              Expected Shipping Location<RedAsterisk />
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          v-if="isSealedUnitOverbooked && sealedUnitOverbookedMessage"
          cols="12"
          class="pt-0"
        >
          <div class="sealed-unit-status-chip sealed-unit-status-chip--overbooked">
            <v-icon
              small
              class="sealed-unit-status-chip__icon"
            >
              mdi-alert-circle
            </v-icon>
            <span>{{ sealedUnitOverbookedMessage }}</span>
          </div>
        </v-col>
      </v-row>
    </template>
  </the-dialog-box>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    item: null,
    status_id: null,
    po_number: null,
    inventory_class_id: null,
    location_id: null,
    locations: [],
    loading: false,
    isSealedUnitOverbooked: false,
    sealedUnitOverbookedMessage: '',
    maximumSealedUnitsAllowedPerDay: 300,
    glassStatusIdNew: 1,
    glassStatusIdIssued: 17,
  }),
  computed: {
    ...mapGetters([
      'businessRulesGetBoolean',
    ]),
  },
  created() {
  },
  methods: {

    async getLocations() {
      this.locations = await this.$api.location.getList();
    },

    async submit() {
      if (this.loading || this.isSealedUnitOverbooked) return false;

      this.loading = true;
      this.resetSealedUnitOverbookedValidation();

      try {
        if (this.status_id == this.glassStatusIdNew) {
          const canIssuePo = await this.checkSealedUnitOverbooking();
          if (!canIssuePo) return false;
        }

        this.$bus.$emit('loading');
        const submitModel = {
          po_number: this.po_number,
          inventory_class_id: this.inventory_class_id,
          status_id: this.status_id == this.glassStatusIdNew ? this.glassStatusIdIssued : this.glassStatusIdNew,
          location_id: this.location_id,
        };
        const res = await this.$api.glass.store(submitModel, 'po-status-issued');
        this.$bus.$emit('loading');

        if (!res) {
          this.$bus.$emit('showError');
          return false;
        }

        this.$emit('success');
        return res;
      } catch {
        this.$bus.$emit('showError');
        return false;
      } finally {
        this.loading = false;
      }
    },

    async checkSealedUnitOverbooking() {
      if (!this.businessRulesGetBoolean('Sealed Unit Overbooking Check')) return true;
      if (!this.po_number || !this.item || !this.item.required_date) return true;

      const sealedUnitCount = parseInt(this.item.total_su, 10) || 0;
      if (sealedUnitCount <= 0) return true;

      const submitModel = {
        glass_required_by: this.item.required_date,
        po_number: this.po_number,
      };

      const overbookingCheck = await this.$api.glass.store(submitModel, 'sealed-unit-overbooking-check');

      if (!overbookingCheck || overbookingCheck.status === 'error') {
        this.$bus.$emit('showError', overbookingCheck && overbookingCheck.message ? overbookingCheck.message : 'Unable to check sealed unit count. Please try again.');
        return false;
      }

      const totalSealedUnitCount = parseInt(overbookingCheck.total_sealed_unit_count, 10) || 0;
      const maximumSealedUnitsAllowedPerDay = parseInt(overbookingCheck.maximum_sealed_units_allowed_per_day, 10) || this.maximumSealedUnitsAllowedPerDay;

      this.maximumSealedUnitsAllowedPerDay = maximumSealedUnitsAllowedPerDay;

      if (overbookingCheck.is_overbooked) {
        const humanReadableDate = moment(this.item.required_date).format('MMMM Do, YYYY');
        this.isSealedUnitOverbooked = true;
        this.sealedUnitOverbookedMessage = `Sorry, there will be ${totalSealedUnitCount} Sealed Units scheduled for ${humanReadableDate}. The maximum allowed is ${maximumSealedUnitsAllowedPerDay}. Please select a different date or reduce Sealed Unit quantity.`;
        return false;
      }

      return true;
    },

    resetSealedUnitOverbookedValidation() {
      this.isSealedUnitOverbooked = false;
      this.sealedUnitOverbookedMessage = '';
    },

    open(item) {
      this.$refs.dialogBox.open();
      this.item = item;
      this.po_number = item.po_number;
      this.inventory_class_id = item.inventory_class_id;
      this.status_id = item.status_id;
      this.loading = false;
      this.resetSealedUnitOverbookedValidation();
      this.getLocations();
    },
  },
};
</script>

<style scoped>
.sealed-unit-status-chip {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  max-width: 100%;
  padding: 8px 12px;
  border-radius: 12px;
}

.sealed-unit-status-chip--overbooked {
  background-color: rgba(244, 67, 54, 0.12);
  color: #B71C1C;
}

.sealed-unit-status-chip__icon {
  margin-right: 6px;
  font-size: 20px !important;
}

.sealed-unit-status-chip--overbooked .sealed-unit-status-chip__icon {
  color: #B71C1C !important;
}

.sealed-unit-status-chip span {
  font-size: 14px !important;
  font-weight: 700;
  line-height: 1.2;
  overflow-wrap: break-word;
}
</style>
